import { type Dispatch } from 'redux';
import { type PayloadAction } from 'typesafe-actions';

import * as D from '../deps';

const AudioPlayerActions = D.Constants.AudioPlayer.AudioPlayerActions;

// @ts-expect-error
export const onSampleEnded = (dispatch, { shouldResumeTrack } = {}) => {
  dispatch({
    type: D.Constants.Samples.SamplePlayerActions.ENDED,
    payload: {
      shouldResumeTrack,
    },
  });
};

// @ts-expect-error
export const onSamplePaused = dispatch => {
  dispatch({
    type: D.Constants.Samples.SamplePlayerActions.PAUSED,
  });
};

// @ts-expect-error
export const onSamplePlaying = (dispatch, url) => {
  dispatch({
    type: D.Constants.Samples.SamplePlayerActions.PLAYING,
    payload: {
      url,
    },
  });
};

interface PlayingPayload {
  CURRENT_TIMESTAMP: $TSFixMe;
  url: $TSFixMe;
  token: $TSFixMe;
  isPreload: $TSFixMe;
  harnessType: $TSFixMe;
}

export type PlayingAction = PayloadAction<typeof AudioPlayerActions.PLAYING, PlayingPayload>;
export const onPlaying = (
  dispatch: Dispatch<PlayingAction>,
  url: $TSFixMe,
  token: $TSFixMe,
  { isPreload, sxmHarnessType }: $TSFixMe,
) => {
  dispatch({
    type: AudioPlayerActions.PLAYING,
    payload: {
      CURRENT_TIMESTAMP: D.Utils.Time.getNow(),
      url,
      token,
      isPreload,
      harnessType: sxmHarnessType || D.Constants.AudioPlayer.AudioHarnessType.P_MEDIA_ELEMENT,
    },
  });
};

interface PausedPayload {
  url: $TSFixMe;
  token: $TSFixMe;
}

export type PausedAction = PayloadAction<typeof AudioPlayerActions.PAUSED, PausedPayload>;
export const onPaused = (dispatch: Dispatch<PausedAction>, url: $TSFixMe, token: $TSFixMe) => {
  dispatch({
    type: AudioPlayerActions.PAUSED,
    payload: {
      url,
      token,
    },
  });
};

interface EndedPayload {
  url: $TSFixMe;
  token: $TSFixMe;
  harnessName: $TSFixMe;
  duration: $TSFixMe;
  currentTime: $TSFixMe;
}

export type EndedAction = PayloadAction<typeof AudioPlayerActions.ENDED, EndedPayload>;
export const onEnded = (
  dispatch: Dispatch<EndedAction>,
  url: $TSFixMe,
  token: $TSFixMe,
  harnessName: $TSFixMe,
  { duration, currentTime }: $TSFixMe = {},
) => {
  dispatch({
    type: AudioPlayerActions.ENDED,
    payload: {
      url,
      token,
      harnessName,
      duration,
      currentTime,
    },
  });
};

interface ErrorPayload {
  ERROR_OBJ: $TSFixMe;
  url: $TSFixMe;
  token: $TSFixMe;
  harnessName: $TSFixMe;
  currentTime: $TSFixMe;
  duration: $TSFixMe;
  isPreload: $TSFixMe;
}

export type ErrorAction = PayloadAction<typeof AudioPlayerActions.ERROR, ErrorPayload>;
export const onError = (
  dispatch: Dispatch<ErrorAction>,
  url: $TSFixMe,
  token: $TSFixMe,
  harnessName: $TSFixMe,
  playerState: $TSFixMe = {},
  error: $TSFixMe,
) => {
  let message;

  /* pull properties we need since ${playerState} can be explicit null */
  const { currentTime = -1, duration = -1, isPreload } = playerState;

  try {
    message = JSON.parse(error.message || '{}');
  } catch (e) {
    message = 'Unable to parse audio playerState error message';
  }

  dispatch({
    type: AudioPlayerActions.ERROR,
    payload: {
      ERROR_OBJ: message,
      url,
      token,
      harnessName,
      currentTime,
      duration,
      isPreload,
    },
  });
};

interface DurationPayload {
  AUDIO_DURATION: $TSFixMe;
  url: $TSFixMe;
  token: $TSFixMe;
}

export type DurationAction = PayloadAction<typeof AudioPlayerActions.DURATION, DurationPayload>;
export const onDurationChange = (
  dispatch: Dispatch<DurationAction>,
  url: $TSFixMe,
  token: $TSFixMe,
  { duration }: $TSFixMe = {},
) => {
  dispatch({
    type: AudioPlayerActions.DURATION,
    payload: {
      AUDIO_DURATION: duration,
      url,
      token,
    },
  });
};

interface UpdatePayload {
  AUDIO_CURRENT_TIME: $TSFixMe;
  AUDIO_DURATION: $TSFixMe;
  CURRENT_TIMESTAMP: $TSFixMe;
  AUDIO_CURRENT_BUFFER_END: $TSFixMe;
  AUDIO_BUFFERED_REMAINING: $TSFixMe;
  url: $TSFixMe;
  token: $TSFixMe;
}

export type UpdateAction = PayloadAction<typeof AudioPlayerActions.UPDATE, UpdatePayload>;
export const onTimeUpdate = (
  dispatch: Dispatch<UpdateAction>,
  url: $TSFixMe,
  token: $TSFixMe,
  { currentTime, duration, buffered, bufferedRemaining }: $TSFixMe = {},
) => {
  dispatch({
    type: AudioPlayerActions.UPDATE,
    payload: {
      AUDIO_CURRENT_TIME: currentTime || 0,
      AUDIO_DURATION: duration,
      CURRENT_TIMESTAMP: D.Utils.Time.getNow(),
      AUDIO_CURRENT_BUFFER_END: buffered,
      AUDIO_BUFFERED_REMAINING: bufferedRemaining,
      url,
      token,
    },
  });
};

interface CanPlayPayload {
  url: $TSFixMe;
  token: $TSFixMe;
}

export type CanPlayAction = PayloadAction<typeof AudioPlayerActions.CAN_PLAY, CanPlayPayload>;
export const onCanPlayThrough = (
  dispatch: Dispatch<CanPlayAction>,
  url: $TSFixMe,
  token: $TSFixMe,
) => {
  dispatch({
    type: AudioPlayerActions.CAN_PLAY,
    payload: {
      url,
      token,
    },
  });
};

interface PlaybackMetricsPayload {
  TRACK_METADATA: $TSFixMe;
  PLAYBACK_METRICS: $TSFixMe;
  url: $TSFixMe;
  token: $TSFixMe;
}

export type PlaybackMetricsAction = PayloadAction<
  typeof AudioPlayerActions.PLAYBACK_METRICS,
  PlaybackMetricsPayload
>;
export const onPlaybackMetrics = (
  dispatch: Dispatch<PlaybackMetricsAction>,
  url: $TSFixMe,
  token: $TSFixMe,
  { playbackMetrics, trackMetadata = {} }: $TSFixMe = {},
) => {
  dispatch({
    type: AudioPlayerActions.PLAYBACK_METRICS,
    payload: {
      TRACK_METADATA: trackMetadata,
      PLAYBACK_METRICS: playbackMetrics,
      url,
      token,
    },
  });
};
